import { useTranslation } from 'next-i18next';

import React from 'react';

import { Modal } from '@thinkific/chalk/Modal';
import { Text } from '@thinkific/chalk/Text';

interface ConfirmDeleteModalProps {
  closeAction(): void;
  confirmDeleteBody: string | JSX.Element;
  confirmDeleteTitle: string;
  confirmDeleteButton?: string;
  deleteAction(): void;
  isConfirmModalOpen: boolean;
  isLoading?: boolean | null;
}

const ConfirmDeleteModal = ({
  confirmDeleteBody,
  confirmDeleteTitle,
  confirmDeleteButton,
  isConfirmModalOpen,
  isLoading = false,
  closeAction,
  deleteAction,
}: ConfirmDeleteModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      contentSurface="primary"
      open={isConfirmModalOpen}
      primaryAction={{
        label: confirmDeleteButton || confirmDeleteTitle,
        onClick: deleteAction,
        isLoading: isLoading || false,
        variant: 'danger',
        dataQa: 'confirm-delete__btn',
      }}
      secondaryAction={{
        label: t('common-cancel', 'Cancel'),
        onClick: closeAction,
      }}
      title={confirmDeleteTitle}
      onClose={closeAction}
    >
      <Text as="p">{confirmDeleteBody}</Text>
    </Modal>
  );
};

export default ConfirmDeleteModal;
